export default "__VITE_ASSET__1c1e1ee1__"